import axios from "axios";

const baseDomain="https://csg-rtparena.gamersmedia.pt";
const baseURL = baseDomain + "/api/v1";

export default axios.create({
   baseURL,
   headers: {'Accept':'application/json'}
});